export enum DeclarationType {
    SEPARATE = 'separate',
    INLINE = 'inline',
    NONE = 'none'
}

export type Settings = {
    declaration: DeclarationType,
    declarationAnswer: boolean
    declarationLabel: string
    declarationLogicSwitched: boolean
    headerText: string,
    footerText: string,
    siteActivities: boolean,
    siteActivitiesLabel?: string,
    siteActivitiesSelect?: string,
    siteActivitiesType?: number,
    siteContacts: boolean,
    siteContactsLabel?: string,
    siteContactsSelect?: string,
    siteRules: boolean,
    siteRulesHeading: string;
}

export type ProfileData = {
    name: string,
    company: string,
    phone: string,
    rememberMe: boolean
}

export type SiteData = {
    name: string;
    timezone: string;
    declaration: string;
    rules: string;
    settings: Settings;
}

export interface StyleData {
    background: string;
    logo: string;
    style: string;
    linkColor: string;
    headerDesign: number;
}

export interface Token {
    token: string;
}

export interface WorkerData {
    id: number;

    firstName: string;
    lastName: string;
    phone: string;

    companyId?: number;
    companyName: string;

    lastSiteLogin?: string;
    lastSiteLogout?: string;
}

export interface CheckinResult {
    worker: WorkerData;
    success: boolean;
}

export interface ContactData {
    workerId: null;
    firstName: string;
    lastName: string;
    firstLastName: string;
    gender: string;
}

export interface ActivityType {
    id: number;
    name: string;
}

export interface Activity {
    activityType: ActivityType;
    description: string;
    id: number;
    name: string;
    workerTypes: string[]
}

export interface ResetData {
    success: boolean;
}
